<template>
  <div v-if="$store.state.wsNoticeKey" class="connection-status" role="status" aria-live="polite">
    {{ $t($store.state.wsNoticeKey) }}
    <button v-if="$store.state.wsShowRetry" type="button" @click="$store.dispatch('recoverWebsocket')">{{ $t('chat.retry') }}</button>
  </div>
</template>

<style scoped>
.connection-status { flex-shrink: 0; padding: 6px 10px; text-align: center; background: #fff4df; color: #805f24; font-size: 12px; }
button { border: 0; padding: 5px 8px; background: transparent; color: #a65832; cursor: pointer; }
</style>
